export enum Sports {
  FOOTBALL = 1,
  ICE_HOCKEY = 2,
  HANDBALL = 3,
}

export type sportRange = Sports.FOOTBALL | Sports.ICE_HOCKEY | Sports.HANDBALL;
